import apiClient from './axios';

export interface DashboardStatsDto {
    totalCourses: number;
    totalForms: number;
    totalSubmissions: number;
    recentSubmissions: number;
    totalMessages: number;
    recentMessages: number;
    pendingNotifications: number;
    failedNotifications: number;
}

export const dashboardApi = {
    getStats: async () => {
        const response = await apiClient.get('/admin/dashboard/stats');
        return response.data;
    }
};
